module.exports = __webpack_public_path__ + "static/dp-82004d293c0676c46cc458071aaafbe0.png";